(function () {
    'use strict';

    angular
     .module('oddQuestionnaireTemplateModule')
     .directive('oddQuestionnaireTemplateStaticText', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addStaticText = '&?';
        directiveScope.toCreateOrUpdate = '&?';
        directiveScope.toDelete = '&?';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
             function ($rootScope, $scope, $controller) {
                 // Box Template
                 $scope.baseTemplatePath = '/app/shared/odd/questionnaireTemplate/oddQuestionnaireTemplateStaticText.[Template].tpl.html';
                 $controller('BoxTmplController', {
                     $scope: $scope
                 });
                 $scope.goToStaticText = function (qTemplateStaticText) {
                     $scope.clickOnBox({
                         questionnaireTemplateStaticText: qTemplateStaticText
                     });
                 };
             }
            ],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();